import { defineAbility } from '@casl/ability'

import { User } from '../../../models'
import { Roles, userHasRole } from '../../../helpers'

export default (user: User) => defineAbility((can) => {
    if (userHasRole(user, Roles.Lead)) {
        can('Edit', 'Arc')
    }
    if (userHasRole(user, Roles.SrLead)) {
        can('Create', 'Arc')
        can('Delete', 'Arc')
    }
})
